const checkExclude = (parts, flatConfigurationParts) => {
    const result = [];
    parts.forEach((part) => {
        const excludes = part.exclude;

        const isDisabled = excludes.filter((exclude) => {
            const found = flatConfigurationParts.filter(
                (selectedItem) => selectedItem.uid === exclude
            );
            return found.length > 0;
        });
        if (isDisabled.length > 0) {
            result.push(part.uid);
        }
    });
    return result;
};

export default checkExclude;
